import styled from 'styled-components'

const ResponsiveSquareContainerMinimal = styled.div`
  position: relative;
  width: 100%;
  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
  overflow: hidden;
  z-index: 1;
  box-shadow: 0px 24px 60px rgba(0, 0, 0, 0.06), 0px 12px 20px rgba(0, 0, 0, 0.05),
    0px 4px 8px rgba(0, 0, 0, 0.02);
  /* filter: drop-shadow(0px 24px 60px rgba(0, 0, 0, 0.06)) drop-shadow(0px 12px 20px rgba(0, 0, 0, 0.05)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.02)); */
  border-radius: 24px;
`

const ResponsiveSquareContainerContentMinimal = styled.div<{}>`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 24px;
`

const ResponsiveSquareContainer = styled.div<{ borderSize?: 'thin' | 'normal' }>`
  position: relative;
  width: 100%;
  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
  background: #26262b;
  ${(props) =>
    props.borderSize === 'thin' &&
    `
    border-radius: 32px;
  `}
  box-shadow: -1px -3px 4px rgba(255, 255, 255, 0.2), 0px 16px 32px rgba(27, 26, 37, 0.24), 0px 12px 24px rgba(27, 26, 37, 0.16), 0px 4px 8px rgba(27, 26, 37, 0.12);
  border-radius: 40px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
      border-radius: 64px;
  `}
`

const ResponsiveSquareContainerContent = styled.div<{
  borderSize?: 'thin' | 'normal'
  bgColor?: string
}>`
  position: absolute;

  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: ${(props) => props.bgColor ?? '#f2b73f'}; */
  /* border-radius: 52px; */
  background-color: ${(props) => props.bgColor ?? '#26262b'};
  /* border-radius: 28px; */
  overflow: hidden;
  /* margin: 12px; */

  ${(props) =>
    props.borderSize &&
    `
      margin: 6px;
      border-radius: 32px;
  `}
  ${({ theme }) => theme.mediaWidth.upToMedium`
      margin: 6px;
      border-radius: 64px;
    `}
`

export {
  ResponsiveSquareContainer,
  ResponsiveSquareContainerContent,
  ResponsiveSquareContainerMinimal,
  ResponsiveSquareContainerContentMinimal,
}
